import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'
import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'

export class FuelTypeValueObject extends ValueObject {
  #name

  #fuelTypeId

  constructor({name, fuelTypeId}) {
    super()
    this.#name = name

    this.#fuelTypeId = fuelTypeId
  }

  get name() {
    return this.#name.value
  }

  get fuelTypeId() {
    return this.#fuelTypeId.value
  }

  get value() {
    return {
      name: this.#name.value,
      fuelTypeId: this.#fuelTypeId.value
    }
  }

  static createFromPrimitives({name, fuelTypeId}) {
    return new FuelTypeValueObject({
      name: StringSharedValueObject.create({value: name}),
      fuelTypeId: NumberSharedValueObject.create({value: fuelTypeId})
    })
  }
}
